export default __webpack_public_path__ + "static/media/1135.7f2bc1f6.png";